<template>
    <section>
        <h1>订单进度</h1>
        <ul>
            <li v-if="followList && followList.length">
                <div v-for="(item, index) in followList" :key="index" class="list-wrap" :class="item.is_show != 1?'no-bottom':''">
                    <template v-if='item.is_show == 1'>
                        <div class="left">
                            <div class="status" v-if="item.is_admin_assist == 2">求协助</div>
                            <div class="status" v-else :class="{ rescind: item.order_status == 6, complete: index == 0, drawback: item.order_status == 9 }">
                                {{ item | filterFollowStatus }}
                            </div>
                            <!-- <div class="time">{{ item.create_time }}</div> -->
                        </div>
                                        
                        <div class="middle" :class="{ reimburse: item.order_status == 6, finish: index == 0, backmoney: item.order_status == 9 }"></div>
                                        
                        <div class="right">
                            <div v-if='item.content' class="content" :class="{ rescind: item.order_status == 6, complete: index == 0, drawback: item.order_status == 9 }">{{ item.content }}</div>
                            
                            <div class="img-content" v-if='item.img && item.img.length'>
                                <el-image v-for="(obj,idx) in item.img" :key="idx" :src="obj" :preview-src-list="item.img" @click.stop="handleClickItem"></el-image>
                            </div>
                            
                            <div class="refund" v-if="item.order_status == '6'">退款</div>
                        </div>
                        <div class="time-line"></div>
                    </template>
                </div>
            </li>
            
            <!-- 固定两条进度 ,未付款转态不展示已付款进度 -->
            <li v-if='orderInfo.order_status!=1'>
                <div class="list-wrap">
                    <div class="left">
                        <div class="status" :class="!(followList && followList.length) && (orderInfo .order_status!=1)?'complete':''">已付款</div>
                        <!-- <div class="time">{{ orderInfo.pay_time}}</div> -->
                    </div>
                    <div class="middle" :class="!(followList && followList.length) && (orderInfo .order_status!=1)?'finish':''"></div>
                    <div class="right">
                        <div class="content" :class="!(followList && followList.length) && (orderInfo .order_status!=1)?'complete':''">订单已付款，正在处理</div>
                    </div>
                    <div class="time-line"></div>
                </div>
            </li>
            
            <li>
                <div class="list-wrap">
                    <div class="left">
                        <div class="status" :class="!(followList && followList.length) && (orderInfo .order_status==1)?'complete':''">待付款</div>
                        <!-- <div class="time">{{ orderInfo.create_time}}</div> -->
                    </div>
                    <div class="middle" :class="!(followList && followList.length) && (orderInfo .order_status==1)?'finish':''"></div>
                    <div class="right">
                        <div class="content" :class="!(followList && followList.length) && (orderInfo .order_status==1)?'complete':''">订单未支付款项，等待付款</div>
                    </div>
                </div>
            </li>
        </ul>
    </section>
</template>
<script>
import ImageUpload from '@/components/ImageUpload.vue';
import { getOrderFollow } from '@/api/order';
import { filterFollowStatus } from '@/filters/index';
export default {
    components: {
        ImageUpload
    },
    data() {
        return {
            imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
            order_uuid: this.$route.query.order_uuid,
            page_index: 1,
            page_size: 25,
            followList: [],
            orderInfo:{}
        };
    },

    created() {
        this.getOrderFollow();
    },

    methods: {
        // 查询跟进订单记录
        async getOrderFollow() {
            const obj = { page_index: this.page_index, page_size: this.page_size };
            const { data, status } = await getOrderFollow(this.order_uuid, obj);
            if (status !== 200) return;
            this.followList = data.data;
            this.orderInfo = data.order_info;
            if(this.orderInfo.pay_time){
                this.orderInfo.pay_time = this.orderInfo.pay_time.slice(5, 10).replace(/-/g, '/')
            }
            if(this.orderInfo.create_time){
                this.orderInfo.create_time = this.orderInfo.create_time.slice(5, 10).replace(/-/g, '/')
            }

            if (this.followList && this.followList.length) {
                for (const item of this.followList) {
                    item.create_time = item.create_time.slice(5, 10).replace(/-/g, '/');
                    if (item.content == '用心淘同意退款') {
                        item.content == '系统审核通过';
                    }
                    if(item.img && item.img.length){
                        item.img.forEach((obj,idx)=>{
                            if(!obj.includes("http") && !obj.includes("https")){
                                item.img[idx] = this.imgUrl + item.img[idx];
                            }
                        })
                    }
                }
            }
        },
        
        handleClickItem(){
            this.$nextTick(()=>{
                // 获取遮罩层dom
                let domImageMask = document.querySelector(".el-image-viewer__mask");
                if (!domImageMask) {
                  return;
                }
                domImageMask.addEventListener("click", () => {
                    // 点击遮罩层时调用关闭按钮的 click 事件
                    document.querySelector(".el-image-viewer__close").click();
                });
            })
        }
    },
};
</script>
<style>
    .el-image-viewer__close{
        color: #fff;
    }
</style>
<style lang="scss" scoped>
h1 {
    @include font-style;
    font-size: 20px;
    color: #000000;
    margin-bottom: 30px;
}
ul {
    // width: 525px;
    background: #ffffff;
    box-shadow: 0px 3px 6px 0px rgba(102, 102, 102, 0.16);
    padding: 45px 10px 0 40px;
    box-sizing: border-box;
    li {
        .list-wrap{
            display: flex;
            position: relative;
            padding-bottom: 50px;
            .left {
                width: 54px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                text-align: right;
                font-size: 18px;
                .status {
                    color: #999999;
                }
                .rescind {
                    color: #333333;
                }
                .complete {
                    color: #ff8d1c;
                }
                .drawback {
                    color: #cccccc;
                }
                .time {
                    font-size: 14px;
                    color: #858585;
                }
            }
            .middle {
                width: 20px;
                height: 20px;
                margin: 0 20px;
                background: url(../../../assets/img/roll.png) no-repeat center;
                background-size: 100%;
                z-index: 2;
            }
            .reimburse {
                background: url(../../../assets/img/rescind.png) no-repeat center;
                background-size: 100%;
            }
            .finish {
                background: url(../../../assets/img/complete.png) no-repeat center;
                background-size: 100%;
            }
            .backmoney {
                background: url(../../../assets/img/drawback.png) no-repeat center;
                background-size: 100%;
            }
            
            .right {
                width: 74%;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
                .content{
                    display: inline-block;
                    margin-bottom: 10px;
                    background: #f8f8f8;
                    box-sizing: border-box;
                    padding:8px 10px;
                    word-break: break-all;
                    font-size: 14px;
                    color: #858585;
                    font-family: Microsoft YaHei;
                }
                .img-content{
                    width: 100%;
                    box-sizing: border-box;
                    background: #FFFFFF;
                	display: flex;
                	align-items: center;
                        .el-image{
                            width: 100px;
                            height: 100px;
                            margin-right: 20px;
                        }
                        .el-image:last-child{
                            margin-right: 0;
                        }
                }
                .refund {
                    width: 338px;
                    height: 42px;
                    line-height: 42px;
                    text-align: center;
                    background: #fff3e6;
                    border: 1px solid #ff8d1c;
                    color: #ff8d1c;
                    @include cursor-style;
                }
                .rescind {
                    color: #333333;
                }
                .complete {
                    color: #ff8d1c;
                }
                .drawback {
                    color: #cccccc;
                }
            }
            .time-line {
                position: absolute;
                left: 82px;
                height: 100%;
                border-left: 4px solid #e6e6e6;
            }
            
            .dankal-image-upload >>> p {
                width: 104px;
                height: 85px;
            }
            .dankal-image-upload >>> .add-box .add {
                width: 104px;
                height: 85px;
            }
        }
        .no-bottom{
            padding-bottom: 0;
        }
    }
}
</style>
